import React from "react";
import styled from "styled-components";
import ViewAppBar from "../views/ViewAppBar";
import ViewCadastroDadosPessoais from "../views/ViewCadastroDadosPessoais";
import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import { useMediaQuery } from "react-responsive";

const ScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  position: relative;
  background: linear-gradient(135deg, #003644, #0096c7);
`;

// 🔹 Área central: mantém o formulário alinhado e o gradiente atrás
const ContentArea = styled.main`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: calc(100vh - 160px); /* compensa AppBar + Footer */
  padding: 2rem 1rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

// 🔹 Botão flutuante do WhatsApp
const ZapContainer = styled.div`
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 50;

  @media (max-width: 768px) {
    bottom: 15px;
    right: 15px;
  }
`;

const CadastroDadosPessoais: React.FC = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <ScreenContainer>
      {/* Cabeçalho */}
      <ViewAppBar />

      {/* Corpo central com fundo azul e formulário */}
      <ContentArea>
        <ViewCadastroDadosPessoais />
      </ContentArea>

      {/* Rodapé */}
      <ViewFooter />

      {/* Botão flutuante do WhatsApp */}
      {!isMobile && (
        <ZapContainer>
          <ContatoZap />
        </ZapContainer>
      )}
    </ScreenContainer>
  );
};

export default CadastroDadosPessoais;
